import Vue from 'vue';

import 'quasar-framework/dist/quasar.ie.polyfills';
import 'quasar-extras/animate';
import 'quasar-extras/roboto-font';
import 'quasar-extras/material-icons';

import {
	QBtn,
	QLayout,
	QLayoutHeader,
	QLayoutDrawer,
	QPage,
	QPageContainer,
	QToolbar,
	QToolbarTitle,
	QList,
	QListHeader,
	QItemSeparator,
	QItem,
	QItemSide,
	QItemMain,

	// start:
	QTabs,
	QRouteTab,
	QSearch,
	QAutocomplete,
	QSelect,
	QInput,
	QField,
	QCard,
	QCardTitle,
	QCardMain,
	QCardSeparator,
	QItemTile,
	QSpinner,
	QAlert,
	QIcon,
	QPageSticky,
	QTooltip,
	QModal,
	QActionSheet,
	QSlideTransition,
	QCheckbox,
	QChip,
	QTab,
	QLayoutFooter,
	QCardActions,
	QPopover,

	// plugins
	Dialog,
	Notify,

	// directives
	Ripple,
	CloseOverlay,

} from 'quasar';

export default {
	components: {
		QBtn,
		QLayout,
		QLayoutHeader,
		QLayoutDrawer,
		QPage,
		QPageContainer,
		QToolbar,
		QToolbarTitle,
		QList,
		QListHeader,
		QItemSeparator,
		QItem,
		QItemSide,
		QItemMain,

		QTabs,
		QRouteTab,
		QSearch,
		QAutocomplete,
		QSelect,
		QInput,
		QField,
		QCard,
		QCardTitle,
		QCardMain,
		QCardSeparator,
		QItemTile,
		QSpinner,
		QAlert,
		QIcon,
		QPageSticky,
		QTooltip,
		QModal,
		QActionSheet,
		QSlideTransition,
		QCheckbox,
		QChip,
		QTab,
		QLayoutFooter,
		QCardActions,
		QPopover,
	},
	directives: {
		Ripple,
		CloseOverlay,
	},
	plugins: {
		Dialog,
		Notify,
	},
};
